module.exports = __webpack_public_path__ + "static/media/password_grey_background.d5a497e7.svg";